import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { CaptchaService } from '../../../services/captcha.service';

/**
 * Captcha réutilisable : affiche une image SVG fournie par le backend
 * et un champ de saisie. Expose le jeton (`token`) et la réponse (`value`).
 *
 * Usage :
 *   <app-captcha [(value)]="captchaAnswer" #captcha></app-captcha>
 *   ... puis à la soumission : captcha.token + this.captchaAnswer
 *   ... après une erreur : captcha.refresh()
 */
@Component({
  selector: 'app-captcha',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
  templateUrl: './captcha.component.html',
  styleUrl: './captcha.component.css',
})
export class CaptchaComponent implements OnInit {
  @Input() value = '';
  @Output() valueChange = new EventEmitter<string>();

  token = '';
  svg: SafeHtml = '';
  loading = false;

  constructor(
    private captcha: CaptchaService,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.refresh();
  }

  refresh(): void {
    this.loading = true;
    this.value = '';
    this.valueChange.emit('');
    this.captcha.get().subscribe({
      next: c => {
        this.token = c.token;
        this.svg = this.sanitizer.bypassSecurityTrustHtml(c.svg);
        this.loading = false;
      },
      error: () => { this.loading = false; },
    });
  }

  onInput(v: string): void {
    this.value = v;
    this.valueChange.emit(v);
  }
}
